<template>
  <div class="border-t border-gray-40 mt-4 <md:-mx-5 <md:px-5 md:mt-2">
    <p class="py-4 text-lg">{{ props.title }}</p>
    <slot />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title: string
}

const props = defineProps<Props>()
</script>
